var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-btn',{attrs:{"color":"info","btnIcon":"mdi-folder-zip"},on:{"click":_vm.onDowloadFile}},[_vm._v(" "+_vm._s(_vm.$t("btn-download-zip-files"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }